import React from "react";
import LayoutHeader from "layouts/LayoutHeader";
import Tabs from "components/ui/tabs/Tabs";

const LayoutHeaderTabs = ({ tabs, layoutHeaderProps = {}, paddingHorizontal = "20px", isVertical = false }) => {
  return (
    <div style={{ paddingLeft: paddingHorizontal, paddingRight: paddingHorizontal }}>
      <LayoutHeader {...layoutHeaderProps} />
      {tabs && tabs.length > 0 && <Tabs tabs={tabs} isVertical={isVertical} />}
    </div>
  );
};

export default LayoutHeaderTabs;
